export { default } from './CharacteristicsCompact';
